import React, {type ReactNode} from 'react';

import cs from 'classnames';
import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

import {getMediaImageSource} from 'app/documents/utils';
import {StyledUserContentDiv} from 'app/procedures/styles';
import {useAccountSettingsState} from 'app/settings/api';

type Props = {
  warningContent?: ReactNode;
  advancedContent?: ReactNode;
  titleContent: ReactNode;
  tagsContent?: ReactNode;
  policyContent?: ReactNode;
  descriptionContent?: ReactNode;
  extraContent?: ReactNode;
  containerClass?: string;
  thumbnail?: string | null;
};
const StyledJumbotronHeader = styled.header.attrs({
  id: 'document-head',
  className: 'jumbotron px-0 mb-0',
})`
  overflow-wrap: break-word;
  background-color: ${colors.lightBg};
`;
const StyledMetaWarningDiv = styled.div`
  &:empty {
    display: none;
  }
`;

const StyledHeaderCover = styled.div<{heroBg?: string}>`
  width: 100%;
  height: 30vh;
  background-image: ${({heroBg}) => `url(${heroBg})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 60%,
      ${colors.lightBg} 100%
    );
  }
`;

export const DocHeaderStructure = ({
  advancedContent,
  titleContent,
  descriptionContent,
  extraContent,
  containerClass = '',
  tagsContent,
  policyContent,
  warningContent,
  thumbnail,
}: Props) => {
  const {MEDIA_URL_READ} = useAccountSettingsState().data!;
  const heroBg = getMediaImageSource(thumbnail, MEDIA_URL_READ, 'original');
  return (
    <>
      <StyledHeaderCover heroBg={heroBg} className={cs({'d-none': !heroBg})} />
      <StyledJumbotronHeader>
        <div className={`container ${containerClass}`}>
          {warningContent !== undefined && (
            <StyledMetaWarningDiv className="pb-4">
              {warningContent}
            </StyledMetaWarningDiv>
          )}
          {advancedContent !== undefined && <div>{advancedContent}</div>}
          {titleContent !== undefined && (
            <div className="jumbotron-heading">{titleContent}</div>
          )}
          {tagsContent !== undefined && <div>{tagsContent}</div>}
          {policyContent !== undefined && <div>{policyContent}</div>}
          {descriptionContent !== undefined && (
            <StyledUserContentDiv>{descriptionContent}</StyledUserContentDiv>
          )}
          {extraContent !== undefined && extraContent}
        </div>
      </StyledJumbotronHeader>
    </>
  );
};
